<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput placeholder="Search by vendor product, company, metadata..." [(ngModel)]="searchValue" (ngModelChange)="queueFilter($event)">
    @if (searchValue) {
      <button mat-icon-button matSuffix aria-label="Clear search" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</div>
<div>
  Item count: {{this.items.data.length}}
</div>
<div #scrollContainer class="scroll-container" (scroll)="onScroll($event)">
  <table class="table" mat-table matSort [dataSource]="items">
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created at</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.createdAt | date:'medium'}}</td>
    </ng-container>
    <ng-container matColumnDef="vendorProductName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor product name</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.vendorProductName}}</td>
    </ng-container>
    <ng-container matColumnDef="exportHealth">
      <th mat-header-cell *matHeaderCellDef>Latest export</th>
      <td class="cell export-health" mat-cell *matCellDef="let item">
        <app-vendor-export-health [health]="$safeNavigationMigration(item.metadata?.exportHealth)"></app-vendor-export-health>
      </td>
    </ng-container>
    <ng-container matColumnDef="metadata">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Metadata</th>
      <td class="cell" mat-cell *matCellDef="let item">{{stringify(item.metadata).substring(0,200) + '...'}}</td>
    </ng-container>
    <ng-container matColumnDef="data">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Data</th>
      <td class="cell" mat-cell *matCellDef="let item">{{stringify(item.data).substring(0,75) + '...'}}</td>
    </ng-container>
    <ng-container matColumnDef="actionmenu" stickyEnd>
      <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item"><button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button></td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.status}}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent let-item="item">
        <button mat-menu-item (click)="editItem(item)">Edit</button>
        <button mat-menu-item (click)="cycleStatus(item)">Cycle status</button>
        <button mat-menu-item (click)="deleteItem(item)">Delete</button>
      </ng-template>
    </mat-menu>
  </table>

  @if (loading) {
    <div class="loading">Loading...</div>
  }
  @if (!loading && items.data.length === 0) {
    <div class="empty">There are no vendor pending transfers to show.</div>
  }
</div>
